<template>
  <div class="vod-question-page">
    <!-- ===== 问卷详情视图：题目管理 ===== -->
    <div v-if="detailQ" class="detail-wrap">
      <div class="detail-head">
        <a-button icon="left" style="margin-right: 12px" @click="backToList">返回问卷列表</a-button>
        <b>问卷 #{{ detailQ.id }}：{{ detailQ.title }}</b>
        <span class="cfg-hint" style="margin-left: 12px">共 {{ questions.length }} 题 · 上移/下移调整顺序</span>
        <a-button type="primary" icon="plus" style="float: right" @click="openQuestionModal()">新增题目</a-button>
      </div>
      <a-table :columns="questionColumns" :data-source="questions" :pagination="false" row-key="id" size="middle" :scroll="{ x: 900 }">
        <template slot="type" slot-scope="text">
          <a-tag :color="typeColor(text)">{{ typeLabel(text) }}</a-tag>
        </template>
        <template slot="isRequired" slot-scope="text">
          <a-tag :color="text === 1 ? 'green' : 'blue'">{{ text === 1 ? '必答' : '选答' }}</a-tag>
        </template>
        <template slot="score" slot-scope="text, record">
          {{ record.type === 'score' ? (record.scoreMin || 1) + '~' + (record.scoreMax || 5) + '分' : (record.questionScore != null ? record.questionScore + '分' : '—') }}
        </template>
        <template slot="standardAnswer" slot-scope="text, record">
          <span :title="text">{{ formatAnswer(record) }}</span>
        </template>
        <template slot="optionCount" slot-scope="text, record">
          {{ (record.options && record.options.length) ? record.options.length + ' 项' : '—' }}
        </template>
        <template slot="action" slot-scope="text, record, index">
          <a-button size="small" :disabled="index === 0" @click="moveQuestion(index, -1)">上移</a-button>
          <a-button size="small" :disabled="index === questions.length - 1" @click="moveQuestion(index, 1)">下移</a-button>
          <a-button size="small" style="margin-left: 6px" @click="openQuestionModal(record.id)">编辑</a-button>
          <a-popconfirm title="确认删除该题目？选项将一并删除" @confirm="delQuestion(record.id)">
            <a-button size="small" type="danger" style="margin-left: 6px">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </div>

    <!-- ===== 问卷列表视图 ===== -->
    <div v-else>
      <div class="toolbar">
        <a-input v-model="qFilter.title" placeholder="问卷名称搜索" allow-clear style="width: 220px" @keyup.enter="loadQuestionnaires(1)" />
        <a-button type="primary" style="margin-left: 8px" @click="loadQuestionnaires(1)">搜索</a-button>
        <a-button type="primary" icon="plus" style="float: right" @click="openQuestionnaireModal()">新建问卷</a-button>
      </div>
      <a-table
        :columns="questionnaireColumns"
        :data-source="questionnaires"
        row-key="id"
        size="middle"
        :loading="qLoading"
        :scroll="{ x: 900 }"
        :pagination="{ current: qPage, pageSize: qPageSize, total: qTotal, showSizeChanger: false }"
        @change="onQTableChange"
      >
        <template slot="status" slot-scope="text">
          <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '禁用' }}</a-tag>
        </template>
        <template slot="config" slot-scope="text, record">
          <a-tag :color="parseConfig(record.configJson).enableScore === false ? 'orange' : 'green'">
            {{ parseConfig(record.configJson).enableScore === false ? '不计分' : '计分' }}
          </a-tag>
          <a-tag v-if="parseConfig(record.configJson).requireAuth === true" color="blue">需认证</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-button type="link" size="small" @click="openDetail(record.id)">题目</a-button>
          <a-button type="link" size="small" style="margin-left: 8px" @click="openPointDrawer(record)">点位</a-button>
          <a-button type="link" size="small" style="margin-left: 8px" @click="openPreview(record.id)">预览</a-button>
          <a-button type="link" size="small" style="margin-left: 8px" @click="showStat(record)">统计</a-button>
          <a-button type="link" size="small" style="margin-left: 8px" @click="openRecordModal(record)">明细</a-button>
          <a-button type="link" size="small" style="margin-left: 8px" @click="exportExcel(record.id)">导出</a-button>
          <a-button type="link" size="small" style="margin-left: 8px" @click="openQuestionnaireModal(record.id)">编辑</a-button>
          <a-button type="link" size="small" style="margin-left: 8px" @click="toggleQuestionnaireStatus(record.id, record.status === 1 ? 0 : 1)">
            {{ record.status === 1 ? '禁用' : '启用' }}
          </a-button>
          <a-popconfirm title="确认删除该问卷？将同时解除其绑定的所有点位" @confirm="delQuestionnaire(record.id)">
            <a-button type="link" size="small" style="margin-left: 8px; color: #f5222d">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </div>

    <!-- ===== 问卷 新建/编辑 弹窗 ===== -->
    <a-modal :visible="qModal.visible" :title="qModal.id ? '编辑问卷 #' + qModal.id : '新建问卷'" @cancel="closeQModal" @ok="saveQuestionnaire" :confirm-loading="qModal.saving" width="520px">
      <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="问卷名称" required>
          <a-input v-model="qForm.title" placeholder="问卷名称" />
        </a-form-model-item>
        <a-form-model-item label="填写提示">
          <a-textarea v-model="qForm.desc" :rows="2" placeholder="播放端弹窗中显示在题目上方的引导语（不填则显示默认提示）" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select v-model="qForm.status" style="width: 200px">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="计分开关">
          <a-switch v-model="qForm.enableScore" checked-children="计分" un-checked-children="不计分" />
          <span class="cfg-hint" style="margin-left: 8px">关闭 = 只收集答案，不判分、无总分，统计不显示分数指标</span>
        </a-form-model-item>
        <a-form-model-item label="认证提示">
          <a-switch v-model="qForm.requireAuth" checked-children="需认证" un-checked-children="否" />
          <span class="cfg-hint" style="margin-left: 8px">开启 = 播放端弹出问卷弹窗后，同时弹出认证弹窗给用户确认认证信息（问卷级配置，所有点位生效）</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- ===== 题目 新增/编辑 弹窗 ===== -->
    <a-modal :visible="quModal.visible" :title="quModal.id ? '编辑题目 #' + quModal.id : '新增题目'" width="640px" @cancel="closeQuModal" @ok="saveQuestion">
      <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="题干" required>
          <a-input v-model="quForm.title" placeholder="题目内容" />
        </a-form-model-item>
        <a-form-model-item label="题型">
          <a-select v-model="quForm.type" style="width: 200px" @change="onQuTypeChange">
            <a-select-option value="radio">单选</a-select-option>
            <a-select-option value="checkbox">多选</a-select-option>
            <a-select-option value="select">下拉选择</a-select-option>
            <a-select-option value="input">填空</a-select-option>
            <a-select-option value="textarea">多行填空</a-select-option>
            <a-select-option value="date">日期选择</a-select-option>
            <a-select-option value="time">时间选择</a-select-option>
            <a-select-option value="score">评分</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="是否必答">
          <a-select v-model="quForm.isRequired" style="width: 200px">
            <a-select-option :value="1">必答</a-select-option>
            <a-select-option :value="0">选答</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="enableScore" label="每题分值">
          <a-input-number v-model="quForm.questionScore" :min="0" :precision="0" />
        </a-form-model-item>
        <a-form-model-item v-if="quForm.type === 'score'" label="评分范围">
          <a-input-number v-model="quForm.scoreMin" :min="0" style="width: 100px" /> ~
          <a-input-number v-model="quForm.scoreMax" :min="0" style="width: 100px" />
        </a-form-model-item>
        <a-form-model-item v-if="enableScore && quForm.type === 'input'" label="参考答案">
          <a-input v-model="quForm.standardAnswer" placeholder="填空题的参考答案（后端按此判分）" />
        </a-form-model-item>
        <a-form-model-item v-if="enableScore && quForm.type === 'textarea'" label="参考答案">
          <a-textarea v-model="quForm.standardAnswer" :rows="2" placeholder="多行填空的参考答案（后端按此判分）" />
        </a-form-model-item>
        <a-form-model-item v-if="enableScore && quForm.type === 'date'" label="参考答案">
          <a-date-picker v-model="dateAnswer" format="YYYY-MM-DD" @change="onDateAnswerChange" placeholder="选择参考答案日期（后端按此判分）" />
        </a-form-model-item>
        <a-form-model-item v-if="enableScore && quForm.type === 'time'" label="参考答案">
          <a-date-picker v-model="timeAnswer" :show-time="{ defaultValue: moment().startOf('day') }" format="YYYY-MM-DD HH:mm:ss" @change="onTimeAnswerChange" placeholder="选择参考答案日期时间（后端按此判分）" style="width: 220px" />
        </a-form-model-item>
        <a-form-model-item v-if="quForm.type === 'radio' || quForm.type === 'checkbox' || quForm.type === 'select'" label="选项">
          <div class="option-list">
            <div v-for="(opt, idx) in quForm.options" :key="idx" class="option-row">
              <span class="idx">{{ idx + 1 }}</span>
              <a-input v-model="opt.content" :placeholder="'选项 ' + String.fromCharCode(65 + idx)" style="flex: 1" />
              <a-checkbox v-if="enableScore" v-model="opt.right">正确</a-checkbox>
              <a-button type="link" size="small" @click="removeOption(idx)">移除</a-button>
            </div>
            <a-button type="dashed" block icon="plus" @click="addOption">添加选项</a-button>
            <div v-if="enableScore" class="cfg-hint" style="margin-top: 6px">在选项下方勾选「正确」即为标准答案（{{ quForm.type === 'radio' || quForm.type === 'select' ? '单选勾 1 个' : '多选可勾多个' }}）；不勾选则该题不判分</div>
          </div>
        </a-form-model-item>
        <a-form-model-item label="显示条件">
          <div class="cond-list">
            <div v-for="(cond, i) in quForm.showConds" :key="i" class="cond-row">
              <a-select v-model="cond.questionId" style="width: 190px" placeholder="前置题目（单选/多选）" @change="onCondQuestionChange(i)">
                <a-select-option v-for="pq in condSourceQuestions" :key="pq.id" :value="pq.id">
                  第{{ questionNo(pq.id) }}题{{ pq.title ? '（' + pq.title + '）' : '' }}
                </a-select-option>
              </a-select>
              <span style="margin: 0 6px; color: #555">作答 =</span>
              <a-select v-model="cond.optionId" style="width: 160px" placeholder="选项">
                <a-select-option v-for="po in condOptionsOf(i)" :key="po.id" :value="po.id">{{ po.content }}</a-select-option>
              </a-select>
              <a-button type="link" size="small" @click="removeCond(i)">移除</a-button>
            </div>
            <a-button type="dashed" block icon="plus" @click="addCond">添加条件</a-button>
            <div class="cfg-hint" style="margin-top: 4px">条件显示：前置单选题作答为该选项时本题才显示（多条需同时满足）；不配置则始终显示。示例：性别题选「男」才显示男性专属题、选「女」才显示女性专属题。多行填空/评分等题目也可设置显示条件，前置题为本题目上方的单选或多选题</div>
          </div>
        </a-form-model-item>
        <a-form-model-item label="答案解析">
          <a-textarea v-model="quForm.answerTip" :rows="2" placeholder="答题后的解析/提示文字" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <questionnaire-preview
      :visible="previewVisible"
      :questionnaire="previewQ"
      @close="previewVisible = false"
    />

    <!-- 视频点位抽屉：右侧弹出，只显示当前问卷的点位（占屏宽 60%） -->
    <vod-point
      :visible="pointDrawer.visible"
      :questionnaire-id="pointDrawer.questionnaireId"
      :questionnaire-title="pointDrawer.questionnaireTitle"
      @close="pointDrawer.visible = false"
    />

    <!-- ===== 统计弹窗（问卷级：统计该问卷所有点位的作答数据） ===== -->
    <a-modal :visible="statModal.visible" :title="'问卷统计 · 问卷 #' + statModal.questionnaireId + ' ' + statModal.questionnaireTitle" :footer="null" :width="'70vw'" @cancel="closeStatModal">
      <div v-if="statLoading" class="stat-loading">加载中…</div>
      <div v-else-if="!statData" class="stat-loading">暂无统计数据</div>
      <div v-else>
        <div class="cfg-hint" style="margin-bottom: 8px">
          弹出次数 = 弹窗出现时播放端上报的 POP 记录数（该问卷所有点位，用户关闭浏览器/强制刷新也计入）；作答率 = 完成 / 弹出次数
        </div>
        <div class="stat-grid">
          <div class="stat-card"><div class="k">弹出次数</div><div class="v">{{ statData.popCount }}</div></div>
          <div class="stat-card"><div class="k">完成作答</div><div class="v">{{ statData.finishCount }}</div></div>
          <div class="stat-card"><div class="k">跳过</div><div class="v">{{ statData.skipCount }}</div></div>
          <div v-if="scored" class="stat-card"><div class="k">平均分</div><div class="v">{{ statData.avgScore }}</div></div>
          <div class="stat-card"><div class="k">作答率</div><div class="v">{{ statData.answerRate }}</div></div>
          <div class="stat-card"><div class="k">跳过率</div><div class="v">{{ statData.skipRate }}</div></div>
          <div class="stat-card"><div class="k">完成率</div><div class="v">{{ statData.finishRate }}</div></div>
        </div>

        <div v-if="scored" class="stat-block">
          <div class="stat-block-title">得分分布（人数）</div>
          <div v-for="k in scoreDistKeys" :key="k" class="bar-row">
            <span class="bar-lbl">{{ k.replace('_', '~') }}</span>
            <div class="bar-track"><div class="bar-fill" :style="{ width: barWidth(statData.scoreDistribute[k], scoreDistMax) }"></div></div>
            <span class="bar-num">{{ statData.scoreDistribute[k] || 0 }}</span>
          </div>
        </div>

        <div v-for="q in statData.questionStats" :key="q.questionId" class="stat-block">
          <div class="stat-block-title">
            {{ q.questionTitle }}
            <a-tag :color="typeColor(q.type)" style="margin-left: 6px">{{ typeLabel(q.type) }}</a-tag>
          </div>
          <div class="cfg-hint" style="margin: 4px 0">
            作答 {{ q.answerCount }} 人
            <template v-if="q.rightRate != null"> · 答对 {{ q.rightCount }} 人 · 正确率 {{ q.rightRate }}</template>
            <template v-else> · 未计分</template>
          </div>
          <div v-for="(v, k) in q.optionDistribute" :key="k" class="bar-row">
            <span class="bar-lbl wide" :title="k">{{ k }}</span>
            <div class="bar-track"><div class="bar-fill" :style="{ width: barWidth(v, optionDistMax(q)) }"></div></div>
            <span class="bar-num">{{ v }}</span>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- ===== 提交明细弹窗（一行 = 一次提交记录；按状态筛选，姓名/手机号搜索） ===== -->
    <a-modal :visible="recModal.visible" :title="'提交明细 · ' + recModal.questionnaireTitle" :footer="null" :width="'70vw'" @cancel="closeRecModal">
      <div class="rec-toolbar">
        <a-select v-model="recFilter.status" placeholder="状态筛选" allow-clear style="width: 150px">
          <a-select-option value="FINISH">已提交</a-select-option>
          <a-select-option value="SKIP">跳过</a-select-option>
          <a-select-option value="POP">弹出</a-select-option>
        </a-select>
        <a-input v-model="recFilter.keyword" placeholder="用户名称/手机号搜索" allow-clear style="width: 220px; margin-left: 8px" @keyup.enter="loadRecords(1)" />
        <a-button type="primary" style="margin-left: 8px" @click="loadRecords(1)">搜索</a-button>
        <a-button style="margin-left: 8px" @click="exportRecords">导出Excel</a-button>
        <span class="cfg-hint" style="margin-left: 12px">共 {{ recTotal }} 条</span>
      </div>
      <a-table
        v-if="recReady"
        :key="recTableKey"
        :columns="recColumns"
        :data-source="records"
        row-key="recordId"
        size="middle"
        :loading="recLoading"
        :scroll="{ x: recScrollX }"
        :pagination="{ current: recPage, pageSize: recPageSize, total: recTotal, showSizeChanger: false }"
        @change="onRecTableChange"
      >
        <template slot="recStatus" slot-scope="text">
          <a-tag :color="text === 'FINISH' ? 'green' : (text === 'SKIP' ? 'orange' : 'blue')">
            {{ text === 'FINISH' ? '已提交' : (text === 'SKIP' ? '跳过' : '弹出') }}
          </a-tag>
        </template>
        <template slot="recAction" slot-scope="text, record">
          <a-popconfirm
            title="删除该条提交记录？删除后该用户可重新作答，统计/导出同步更新。"
            ok-text="删除"
            cancel-text="取消"
            @confirm="deleteRecord(record)"
          >
            <a type="link" style="color: #f5222d">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { get, post, put, del, EXPORT_BASE } from './api'
import { typeLabel, typeColor, parseConfig, formatAnswer } from './util'
import QuestionnairePreview from './QuestionnairePreview'
import VodPoint from './vodPoint'
import moment from 'moment'

export default {
  name: 'VodQuestionnaire',
  components: { QuestionnairePreview, VodPoint },
  data() {
    return {
      moment: moment, // 供模板 :show-time defaultValue 使用
      questionnaires: [],
      qLoading: false,
      qPage: 1,
      qPageSize: 10,
      qTotal: 0,
      qFilter: { title: '' },

      detailQ: null,
      questions: [],

      qModal: { visible: false, id: null, saving: false },
      qForm: { title: '', desc: '', status: 1, enableScore: false, requireAuth: false },

      quModal: { visible: false, id: null, saving: false },
      quForm: this.blankQuestionForm(),
      // 日期/时间参考答案的 moment 对象（a-date-picker / a-time-picker 双向绑定，change 时格式化写回 quForm.standardAnswer）
      dateAnswer: null,
      timeAnswer: null,

      previewVisible: false,
      previewQ: null,

      statModal: { visible: false, questionnaireId: null, questionnaireTitle: '' },
      statData: null,
      statLoading: false,

      pointDrawer: { visible: false, questionnaireId: null, questionnaireTitle: '' },

      recModal: { visible: false, questionnaireId: null, questionnaireTitle: '' },
      recSeq: 0,
      recReady: false,
      recFilter: { status: 'FINISH', keyword: '' },
      records: [],
      recQuestions: [],
      recLoading: false,
      recPage: 1,
      recPageSize: 10,
      recTotal: 0
    }
  },
  computed: {
    // 当前问卷是否计分（configJson.enableScore !== false）；不计分时隐藏分值/标准答案相关字段
    enableScore() {
      if (!this.detailQ || !this.detailQ.configJson) return true
      return parseConfig(this.detailQ.configJson).enableScore !== false
    },
    questionnaireColumns() {
      return [
        { title: '序号', key: 'rowNum', width: 60, customRender: (text, record, index) => index + 1 },
        { title: 'ID', dataIndex: 'id', width: 70 },
        { title: '问卷名称', dataIndex: 'title' },
        { title: '填写提示', dataIndex: 'desc', ellipsis: true },
        { title: '状态', dataIndex: 'status', width: 80, scopedSlots: { customRender: 'status' } },
        { title: '计分/认证', dataIndex: 'configJson', width: 150, scopedSlots: { customRender: 'config' } },
        { title: '创建时间', dataIndex: 'createdTime', width: 170 },
        { title: '操作', key: 'action', width: 430, scopedSlots: { customRender: 'action' } }
      ]
    },
    questionColumns() {
      return [
        { title: '序号', key: 'rowNum', width: 60, customRender: (text, record, index) => index + 1 },
        { title: 'ID', dataIndex: 'id', width: 70 },
        { title: '题干', dataIndex: 'title' },
        { title: '类型', dataIndex: 'type', width: 90, scopedSlots: { customRender: 'type' } },
        { title: '必答', dataIndex: 'isRequired', width: 80, scopedSlots: { customRender: 'isRequired' } },
        ...(this.enableScore ? [
          { title: '分值', dataIndex: 'questionScore', width: 110, scopedSlots: { customRender: 'score' } },
          { title: '标准答案', dataIndex: 'standardAnswer', width: 200, scopedSlots: { customRender: 'standardAnswer' } }
        ] : []),
        { title: '选项数', key: 'optionCount', width: 90, scopedSlots: { customRender: 'optionCount' } },
        { title: '操作', key: 'action', width: 250, scopedSlots: { customRender: 'action' } }
      ]
    },
    condSourceQuestions() {
      // 只允许选择本题上方的单选/多选/下拉选择作为前置题（排序在当前题之前、有选项的题）
      const id = this.quForm && this.quForm.id
      const mySort = this.quForm && this.quForm.sortIndex
      return this.questions.filter(q => {
        if ((q.type !== 'radio' && q.type !== 'checkbox' && q.type !== 'select') || q.id === id) return false
        if (mySort != null && q.sortIndex != null) return q.sortIndex < mySort
        return true
      })
    },
    scored() {
      return this.statData && this.statData.avgScore != null
    },
    scoreDistKeys() {
      return ['0_30', '30_60', '60_80', '80_100']
    },
    scoreDistMax() {
      const dist = (this.statData && this.statData.scoreDistribute) || {}
      return Math.max(1, ...Object.values(dist).map(Number))
    },
    recColumns() {
      // 固定列（左右滑动时固定）：问卷ID、问卷名称、用户ID、用户名称
      const fixed = [
        { title: '问卷ID', dataIndex: 'questionnaireId', width: 90, fixed: 'left' },
        { title: '问卷名称', dataIndex: 'questionnaireTitle', ellipsis: true, width: 180, fixed: 'left' },
        { title: '用户ID', dataIndex: 'userId', ellipsis: true, width: 220, fixed: 'left' },
        { title: '用户名称', dataIndex: 'userName', width: 140, scopedSlots: { customRender: 'userName' }, fixed: 'left' }
      ]
      const middle = [
        { title: '手机号', dataIndex: 'tel', width: 140, scopedSlots: { customRender: 'tel' } },
        { title: '状态', dataIndex: 'status', width: 100, scopedSlots: { customRender: 'recStatus' } },
        { title: '弹出时间点', dataIndex: 'triggerTime', width: 110, scopedSlots: { customRender: 'triggerTime' } },
        { title: '作答时间', dataIndex: 'answerTime', width: 170 },
        { title: '视频标题', dataIndex: 'videoTitle', ellipsis: true, width: 200 },
        { title: '专题名称', dataIndex: 'topicTitle', width: 160 },
        { title: 'IP', dataIndex: 'ip', width: 140 }
      ]
      const qcols = (this.recQuestions || []).map((q, i) => ({
        title: `题${i + 1}:${q.title}`,
        dataIndex: 'q_' + q.id,
        ellipsis: true,
        width: 180
      }))
      const action = [
        { title: '操作', key: 'action', width: 90, fixed: 'right', scopedSlots: { customRender: 'recAction' } }
      ]
      return fixed.concat(middle, qcols, action)
    },
    recScrollX() {
      const qw = (this.recQuestions || []).length * 180
      return 630 + 140 + 100 + 110 + 170 + 200 + 160 + 140 + qw + 90
    },
    recTableKey() {
      return this.recModal.questionnaireId + '-' + this.recSeq + '-' + (this.recQuestions || []).length
    }
  },  methods: {
    typeLabel,
    typeColor,
    parseConfig,
    formatAnswer,

    /* ===== 统计 & 导出（问卷级，跨点位聚合） ===== */
    openPointDrawer(record) {
      this.pointDrawer.questionnaireId = record.id
      this.pointDrawer.questionnaireTitle = record.title || ''
      this.pointDrawer.visible = true
    },

    /* ===== 提交明细（一行 = 一次提交记录） ===== */
    openRecordModal(record) {
      this.recModal.questionnaireId = record.id
      this.recModal.questionnaireTitle = record.title || ('问卷 #' + record.id)
      this.recModal.visible = true
      this.recSeq += 1
      this.recReady = false
      this.recFilter = { status: 'FINISH', keyword: '' }
      this.records = []
      this.recQuestions = []
      this.loadRecords(1)
      // 弹窗展开动画完成后才渲染表格，fixed 列按最终宽度渲染，避免先错位再恢复
      setTimeout(() => { this.recReady = true; this.recSeq += 1 }, 350)
    },
    loadRecords(page) {
      this.recLoading = true
      get('/vod/questionnaire/record/list', {
        questionnaireId: this.recModal.questionnaireId,
        status: this.recFilter.status || undefined,
        keyword: this.recFilter.keyword || undefined,
        pageNum: page || 1,
        pageSize: this.recPageSize
      }).then(body => {
        const d = body.data || {}
        this.records = d.records || []
        this.recTotal = d.count != null ? d.count : this.records.length
        this.recQuestions = d.questions || []
        this.recPage = page || 1
      }).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.recLoading = false
      })
    },
    onRecTableChange(pagination) {
      this.loadRecords(pagination.current)
    },
    deleteRecord(row) {
      del('/vod/questionnaire/record/' + row.recordId).then(() => {
        this.$message.success('已删除该条提交记录')
        // 删除后刷新当前页；若当前页删空则回退一页
        const remain = this.records.length - 1
        const page = remain > 0 ? this.recPage : Math.max(1, this.recPage - 1)
        this.loadRecords(page)
      }).catch(e => {
        this.$message.error(e.message)
      })
    },
    exportRecords() {
      const params = []
      params.push('questionnaireId=' + this.recModal.questionnaireId)
      if (this.recFilter.status) params.push('status=' + this.recFilter.status)
      if (this.recFilter.keyword) params.push('keyword=' + encodeURIComponent(this.recFilter.keyword))
      window.open(EXPORT_BASE + '/vod/questionnaire/record/export?' + params.join('&'), '_blank')
    },
    closeRecModal() {
      this.recModal.visible = false
    },
    showStat(record) {
      this.statModal.questionnaireId = record.id
      this.statModal.questionnaireTitle = record.title || ''
      this.statModal.visible = true
      this.statData = null
      this.statLoading = true
      get('/vod/questionnaire/' + record.id + '/statistics').then(body => {
        this.statData = body.data
      }).catch(e => {
        this.statData = null
        this.$message.error(e.message)
      }).finally(() => {
        this.statLoading = false
      })
    },
    closeStatModal() {
      this.statModal.visible = false
    },
    exportExcel(id) {
      window.open(EXPORT_BASE + '/vod/questionnaire/' + id + '/export', '_blank')
    },
    barWidth(v, max) {
      return Math.round(((v || 0) / max) * 100) + '%'
    },
    optionDistMax(q) {
      const opts = q.optionDistribute || {}
      return Math.max(1, ...Object.values(opts).map(Number))
    },

    blankQuestionForm() {
      return {
        id: null, title: '', type: 'radio', isRequired: 1, questionScore: 1,
        scoreMin: 1, scoreMax: 5, standardAnswer: '', answerTip: '',
        options: [{ content: '', right: false }],
        showConds: []
      }
    },

    /* ===== 问卷列表 ===== */
    loadQuestionnaires(page) {
      this.qLoading = true
      get('/vod/questionnaire/list', {
        title: this.qFilter.title || undefined,
        pageNum: page || 1,
        pageSize: this.qPageSize
      }).then(body => {
        this.questionnaires = body.data || []
        this.qTotal = body.count != null ? body.count : this.questionnaires.length
        this.qPage = page || 1
      }).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.qLoading = false
      })
    },
    onQTableChange(pagination) {
      this.loadQuestionnaires(pagination.current)
    },
    openQuestionnaireModal(id) {
      this.qModal.id = id || null
      this.qForm = { title: '', desc: '', status: 1, enableScore: false, requireAuth: false }
      this.qModal.visible = true
      if (id) {
        get('/vod/questionnaire/' + id).then(body => {
          const q = body.data
          const cfg = parseConfig(q.configJson)
          this.qForm = {
            title: q.title || '',
            desc: q.desc || '',
            status: q.status == null ? 1 : q.status,
            enableScore: cfg.enableScore !== false,
            requireAuth: cfg.requireAuth === true
          }
        }).catch(e => this.$message.error(e.message))
      }
    },
    closeQModal() {
      if (!this.qModal.saving) this.qModal.visible = false
    },
    saveQuestionnaire() {
      if (!this.qForm.title || !this.qForm.title.trim()) {
        this.$message.error('问卷名称不能为空')
        return
      }
      const payload = {
        title: this.qForm.title.trim(),
        desc: (this.qForm.desc || '').trim(),
        status: this.qForm.status,
        configJson: { enableScore: !!this.qForm.enableScore, requireAuth: !!this.qForm.requireAuth }
      }
      this.qModal.saving = true
      const req = this.qModal.id ? put('/vod/questionnaire', Object.assign({ id: this.qModal.id }, payload)) : post('/vod/questionnaire', payload)
      req.then(body => {
        this.$message.success(this.qModal.id ? '问卷已更新' : '问卷已创建（ID=' + body.data + '）')
        this.qModal.visible = false
        this.loadQuestionnaires(this.qPage)
      }).catch(e => this.$message.error(e.message)).finally(() => {
        this.qModal.saving = false
      })
    },
    toggleQuestionnaireStatus(id, status) {
      put('/vod/questionnaire', { id: id, status: status }).then(() => {
        this.$message.success(status === 1 ? '问卷已启用' : '问卷已禁用')
        this.loadQuestionnaires(this.qPage)
      }).catch(e => this.$message.error(e.message))
    },
    delQuestionnaire(id) {
      del('/vod/questionnaire/' + id).then(() => {
        this.$message.success('已删除')
        this.loadQuestionnaires(this.qPage)
      }).catch(e => this.$message.error(e.message))
    },

    /* ===== 问卷详情：题目管理 ===== */
    openDetail(id) {
      get('/vod/questionnaire/' + id).then(body => {
        this.detailQ = body.data
        this.questions = body.data.questions || []
      }).catch(e => this.$message.error(e.message))
    },
    openPreview(id) {
      get('/vod/questionnaire/' + id).then(body => {
        this.previewQ = body.data
        this.previewVisible = true
      }).catch(e => this.$message.error(e.message))
    },
    backToList() {
      this.detailQ = null
      this.questions = []
      this.loadQuestionnaires(this.qPage)
    },
    moveQuestion(idx, dir) {
      const j = idx + dir
      if (j < 0 || j >= this.questions.length) return
      const tmp = this.questions[idx]
      this.$set(this.questions, idx, this.questions[j])
      this.$set(this.questions, j, tmp)
      const ids = this.questions.map(q => q.id)
      put('/vod/questionnaire/question/sort', ids).then(() => {
        this.$message.success('顺序已更新')
      }).catch(e => this.$message.error('顺序保存失败：' + e.message))
    },

    /* ===== 题目 新增/编辑/删除 ===== */
    openQuestionModal(id) {
      this.quModal.id = id || null
      this.quForm = this.blankQuestionForm()
      this.dateAnswer = null
      this.timeAnswer = null
      this.quModal.visible = true
      if (id) {
        get('/vod/questionnaire/question/' + id).then(body => {
          const q = body.data
          const opts = (q.options && q.options.length) ? q.options : [{ content: '', right: false }]
          const rightIds = {}
          if (q.standardAnswer) {
            String(q.standardAnswer).split('、').forEach(s => { if (s.trim()) rightIds[String(s.trim())] = true })
          }
          const conds = []
          if (q.showCondition && typeof q.showCondition === 'object') {
            Object.keys(q.showCondition).forEach(k => {
              if (q.showCondition[k] != null) conds.push({ questionId: Number(k), optionId: q.showCondition[k] })
            })
          }
          this.quForm = {
            id: q.id,
            title: q.title || '',
            type: q.type || 'radio',
            isRequired: q.isRequired == null ? 1 : q.isRequired,
            questionScore: q.questionScore != null ? q.questionScore : 1,
            scoreMin: q.scoreMin != null ? q.scoreMin : 1,
            scoreMax: q.scoreMax != null ? q.scoreMax : 5,
            standardAnswer: q.standardAnswer || '',
            answerTip: q.answerTip || '',
            sortIndex: q.sortIndex,
            options: opts.map(o => ({
              id: o.id,
              content: o.content,
              right: o.id != null && rightIds[String(o.id)] === true
            })),
            showConds: conds
          }
          if (!this.quForm.options.length) this.quForm.options = [{ content: '', right: false }]
          // 日期/时间参考答案回填为 moment 对象（供 a-date-picker 双向绑定；time 为年月日时分秒）
          this.dateAnswer = (q.type === 'date' && q.standardAnswer) ? moment(q.standardAnswer, 'YYYY-MM-DD') : null
          this.timeAnswer = (q.type === 'time' && q.standardAnswer) ? moment(q.standardAnswer, 'YYYY-MM-DD HH:mm:ss') : null
        }).catch(e => this.$message.error(e.message))
      }
    },
    closeQuModal() {
      if (!this.quModal.saving) this.quModal.visible = false
    },
    onQuTypeChange() {
      this.quForm.options = [{ content: '', right: false }]
      this.quForm.showConds = []
      this.quForm.standardAnswer = ''
      this.dateAnswer = null
      this.timeAnswer = null
      if (this.quForm.type === 'score') {
        this.quForm.scoreMin = 1
        this.quForm.scoreMax = 5
      }
    },
    // 日期参考答案选择：moment 对象 → 字符串写回 standardAnswer
    onDateAnswerChange(d) {
      this.quForm.standardAnswer = d ? d.format('YYYY-MM-DD') : ''
    },
    // 时间参考答案选择：moment 对象 → 字符串写回 standardAnswer（年月日时分秒）
    onTimeAnswerChange(t) {
      this.quForm.standardAnswer = t ? t.format('YYYY-MM-DD HH:mm:ss') : ''
    },
    addOption() {
      this.quForm.options.push({ content: '', right: false })
    },
    addCond() {
      this.quForm.showConds.push({ questionId: undefined, optionId: undefined })
    },
    removeCond(i) {
      this.quForm.showConds.splice(i, 1)
    },
    onCondQuestionChange(i) {
      this.quForm.showConds[i].optionId = undefined
    },
    condOptionsOf(i) {
      const cond = this.quForm.showConds[i]
      if (!cond || cond.questionId == null) return []
      const pq = this.questions.filter(x => x.id === cond.questionId)[0]
      return (pq && pq.options) ? pq.options : []
    },
    questionNo(targetId) {
      const i = this.questions.findIndex(x => x.id === targetId)
      return i >= 0 ? i + 1 : '?'
    },
    removeOption(idx) {
      this.quForm.options.splice(idx, 1)
      if (!this.quForm.options.length) this.quForm.options = [{ content: '', right: false }]
    },
    delQuestion(id) {
      del('/vod/questionnaire/question/' + id).then(() => {
        this.$message.success('已删除')
        this.openDetail(this.detailQ.id)
      }).catch(e => this.$message.error(e.message))
    },
    saveQuestion() {
      if (!this.quForm.title || !this.quForm.title.trim()) {
        this.$message.error('题干不能为空')
        return
      }
      const type = this.quForm.type
      const payload = {
        questionnaireId: this.detailQ.id,
        title: this.quForm.title.trim(),
        type: type,
        isRequired: this.quForm.isRequired,
        questionScore: this.quForm.questionScore || 0,
        scoreMin: type === 'score' ? (this.quForm.scoreMin || 1) : null,
        scoreMax: type === 'score' ? (this.quForm.scoreMax || 5) : null,
        standardAnswer: type === 'score' ? '' : (this.quForm.standardAnswer || '').trim(),
        answerTip: (this.quForm.answerTip || '').trim()
      }
      if (type === 'radio' || type === 'checkbox' || type === 'select') {
        const options = []
        const correctIdx = []
        this.quForm.options.forEach((o, i) => {
          const content = (o.content || '').trim()
          if (content) {
            options.push({ id: o.id || null, content: content })
          }
          if (o.right) correctIdx.push(i)
        })
        if (!options.length) {
          this.$message.error('单选/多选/下拉选择至少需要一个选项')
          return
        }
        payload.options = options
        if (correctIdx.length) {
          payload.correctIndexes = correctIdx.join('、')
        }
      }
      // 显示条件（所有题型均可配置，统一保存）
      const sc = {}
      this.quForm.showConds.forEach(c => {
        if (c.questionId != null && c.optionId != null) sc[String(c.questionId)] = c.optionId
      })
      if (Object.keys(sc).length) {
        payload.showCondition = sc
      }
      this.quModal.saving = true
      const req = this.quModal.id ? put('/vod/questionnaire/question', Object.assign({ id: this.quModal.id }, payload)) : post('/vod/questionnaire/question', payload)
      req.then(() => {
        this.$message.success(this.quModal.id ? '题目已更新' : '题目已创建')
        this.quModal.visible = false
        this.openDetail(this.detailQ.id)
      }).catch(e => this.$message.error(e.message)).finally(() => {
        this.quModal.saving = false
      })
    }
  },
  mounted() {
    this.loadQuestionnaires(1)
  }
}
</script>

<style scoped>
.vod-question-page { padding: 16px; }
.cfg-hint { font-size: 12px; color: #8b9aab; }
.toolbar { margin-bottom: 12px; }
.detail-wrap {
  border: 1px solid #e8e8e8; border-radius: 4px; padding: 12px; background: #fff;
}
.detail-head { margin-bottom: 12px; line-height: 32px; }
.option-list { width: 100%; }
.option-row {
  display: flex; align-items: center; margin-bottom: 6px;
}
.cond-list { width: 100%; }
.cond-row {
  display: flex; align-items: center; margin-bottom: 6px;
}
.option-row .idx {
  width: 24px; text-align: center; color: #999; flex: none;
}
.option-row .ant-checkbox-wrapper { margin: 0 10px; flex: none; }
.stat-loading { text-align: center; color: #8b9aab; padding: 30px 0; }
.rec-toolbar { margin-bottom: 12px; }
.stat-grid {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; margin-bottom: 16px;
}
.stat-card {
  border: 1px solid #eee; border-radius: 4px; padding: 10px 12px; background: #fafafa;
}
.stat-card .k { font-size: 12px; color: #8b9aab; }
.stat-card .v { font-size: 22px; font-weight: 600; margin-top: 2px; }
.stat-block {
  border: 1px solid #eee; border-radius: 4px; padding: 10px 12px; margin-bottom: 12px;
}
.stat-block-title { font-weight: 600; margin-bottom: 6px; }
.bar-row { display: flex; align-items: center; margin: 4px 0; }
.bar-lbl { width: 70px; flex: none; font-size: 12px; color: #555; }
.bar-lbl.wide { width: 130px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bar-track { flex: 1; background: #f0f0f0; border-radius: 2px; height: 14px; margin: 0 8px; }
.bar-fill { height: 14px; background: #1890ff; border-radius: 2px; transition: width .3s; }
.bar-num { width: 40px; flex: none; text-align: right; font-size: 12px; }
@media (max-width: 720px) {
  .stat-grid { grid-template-columns: repeat(2, 1fr); }
}
</style>
